import { motion } from "framer-motion";
import { Mark } from "@/components/Motif";
import { EASE } from "@/components/Reveal";

export default function Loader() {
  return (
    <motion.div
      data-testid="loader"
      className="fixed inset-0 z-[100] bg-cocoa-950 flex flex-col items-center justify-center"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ scale: 0.6, opacity: 0, rotate: -20 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ duration: 0.6, ease: EASE }}
        className="text-gold"
      >
        <Mark className="w-12 h-12" />
      </motion.div>
      <div className="mt-5 overflow-hidden">
        <motion.p
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ delay: 0.15, duration: 0.7, ease: EASE }}
          className="font-display text-2xl tracking-[0.18em] text-cream"
        >
          SAMIJ SWEETS
        </motion.p>
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.45 }}
        className="mt-2 text-[11px] uppercase tracking-[0.35em] text-gold/70"
      >
        Banskandi
      </motion.p>
    </motion.div>
  );
}
